module.exports = __webpack_public_path__ + "img/hb.f11aa44f.jpg";